import { render } from "./TenantsPage.vue?vue&type=template&id=706d44e6&scoped=true"
import script from "./TenantsPage.vue?vue&type=script&lang=js"
export * from "./TenantsPage.vue?vue&type=script&lang=js"

import "./TenantsPage.vue?vue&type=style&index=0&id=706d44e6&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Pacto_console/Pacto_console/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-706d44e6"]])

export default __exports__